// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5facb224","977":"a39208e4"}[chunkId] + ".chunk.js";
};